import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { SquaresFour, Eye, EyeSlash } from "@phosphor-icons/react";

// Keep in sync with CATEGORY_META keys in /app/frontend/src/pages/RequestQuote.jsx.
// These are the 8 project-type tiles shown to customers at Step 1 of Request-Quote.
const PROJECT_TYPES = [
  "Logo & Branding",
  "Print Design",
  "Social Media Graphics",
  "Website Design",
  "Promotional Campaigns",
  "Business Stationery",
  "Signage & Display",
  "Print-Ready Artwork",
];

export default function ProjectTypesSection() {
  const [hidden, setHidden] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/project-types/hidden");
      setHidden(data.hidden || []);
    } catch { /* keep default */ }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (name) => {
    const nextHidden = !hidden.includes(name);
    try {
      const { data } = await api.post("/admin/hidden-project-types/toggle", { project_type: name, hidden: nextHidden });
      setHidden(data.hidden || []);
      toast.success(nextHidden ? `"${name}" hidden from customers` : `"${name}" visible to customers`);
    } catch { toast.error("Toggle failed"); }
  };

  return (
    <div className="sticker p-6 mt-6" data-testid="project-types-card">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-12 h-12 bg-[var(--gc-navy)] text-white flex items-center justify-center border-2 border-[var(--gc-navy)]">
          <SquaresFour size={22} weight="bold" />
        </div>
        <h2 className="font-display text-3xl">Project Types</h2>
      </div>
      <p className="text-sm text-[var(--gc-text-muted)] mb-4">
        The 8 tiles shown on Step 1 of the customer&apos;s Request-Quote flow. Hide any you don&apos;t currently offer — hidden tiles disappear from the customer view but stay editable here.
      </p>
      {loading ? (
        <div className="tech-label">// loading…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {PROJECT_TYPES.map((name) => {
            const isHidden = hidden.includes(name);
            return (
              <button
                key={name}
                onClick={() => toggle(name)}
                className={`flex items-center justify-between px-4 py-3 border-2 text-left transition-colors ${isHidden ? 'border-[var(--gc-orange)] bg-[#fff5f2]' : 'border-[var(--gc-navy)] bg-white hover:bg-[var(--gc-bg-alt)]'}`}
                data-testid={`pt-toggle-${name.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`}
              >
                <span className={`font-semibold ${isHidden ? 'text-[var(--gc-text-muted)]' : ''}`}>{name}</span>
                <span className={`inline-flex items-center gap-1 text-xs font-semibold ${isHidden ? 'text-[var(--gc-orange)]' : 'text-[var(--gc-navy)]'}`}>
                  {isHidden ? <><EyeSlash size={14} weight="bold"/> Hidden</> : <><Eye size={14} weight="bold"/> Visible</>}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
